export default __webpack_public_path__ + "static/average-time-to-convert-light-mode-99d0167b35e3e6961ffa6029b5e2f7e6.png";